import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IAddFrontdeskLocation, IEditFrontdeskLocation, IFrontdeskLocation, IFrontdeskLocations } from './frontdesk-locations.model';

@Injectable()
export class FrontdeskLocationsService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'events/{eventId}/frontdesklocations';

    public addFrontdeskLocation(eventId: string, location: IAddFrontdeskLocation): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<boolean>>(
                FrontdeskLocationsService.URL +
                FrontdeskLocationsService.ENDPOINT.replace('{eventId}', eventId),
                location
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public updateFrontdeskLocation(eventId: string, location: IEditFrontdeskLocation): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .put<SuccessResponse<boolean>>(
                FrontdeskLocationsService.URL +
                FrontdeskLocationsService.ENDPOINT.replace('{eventId}', eventId) +
                `/${location.id}`,
                location
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getFrontdeskLocation(eventId: string, id: string): Observable<SuccessResponse<IFrontdeskLocation> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IFrontdeskLocation>>(
                FrontdeskLocationsService.URL +
                FrontdeskLocationsService.ENDPOINT.replace('{eventId}', eventId) +
                `/${id}`
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getFrontdeskLocations(eventId: string): Observable<SuccessResponse<IFrontdeskLocations> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IFrontdeskLocations>>(
                FrontdeskLocationsService.URL +
                FrontdeskLocationsService.ENDPOINT.replace('{eventId}', eventId)
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public deleteFrontdeskLocation(eventId: string, id: string): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
            .delete<SuccessResponse<boolean>>(
                FrontdeskLocationsService.URL +
                FrontdeskLocationsService.ENDPOINT.replace('{eventId}', eventId) +
                `/${id}`
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
